document.addEventListener('DOMContentLoaded', function () {
  function updateDeliveryTimeVisibility() {
    const now = new Date();

    // Convert to AEST (UTC+10 or UTC+11 for daylight saving if needed)
    const aestOffset = 10; // Change to 11 if daylight saving applies
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const aestTime = new Date(utc + 3600000 * aestOffset);

    const hours = aestTime.getHours();
    const minutes = aestTime.getMinutes();

    const deliveryCon = document.querySelector('.deliveryCon');
    if (!deliveryCon) return;

    // Hide .deliveryCon (and its children) if current time is between 4:00 PM and 11:59 PM AEST
    if ((hours === 16 && minutes >= 0) || (hours > 16 && hours < 24)) {
      deliveryCon.style.display = 'none';
    } else {
      deliveryCon.style.display = '';
    }
  }

  updateDeliveryTimeVisibility(); // Run on load
  setInterval(updateDeliveryTimeVisibility, 60000); // Update every minute
});
